import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

export interface DashboardState {
  dirtyCount: number;
}
/**
 * We need a numerical change indicator, a simple boolean doesn't fit, (it would simply not fire after the first toggle from false -> true) because we want to be able to mark dirty multiple times before resetting,
 * and we don't want to lose track of how many changes were made if we reset in between without saving
 */
const initialState: DashboardState = {
  dirtyCount: 0,
};

// This is called dashboard store, because it will be used as such
// but for now it'll be used to handle the isUnsaved checks and resetting after save
export const DashboardStore = signalStore(
  withState(initialState),
  withComputed((state) => ({
    isDirty: computed(() => state.dirtyCount() > 0),
  })),
  withMethods((store) => ({
    markDirty: () => {
      patchState(store, { dirtyCount: store.dirtyCount() + 1 });
    },
    reset: () => {
      patchState(store, { dirtyCount: 0 });
    },
  }))
);
